"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Card.pc.css");
const Card = ({ onClick, style, hover, interactive, withAction, spaced, reverse, bgSecondary, className, testId, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_943d99a4', '_3f8a8a2', '_pub-3f8a8a2', '_pub-3c25d522', '_3f8a8a2_text-body-medium', '_pub-3f8a8a2_text-body-medium', '_pub-3c25d522_text-body-medium', 'text-body-medium', '_3f8a8a2_v3', '_pub-3f8a8a2_v3', '_pub-3c25d522_v3', 'v3', {
            '_3f8a8a2_hover _pub-3f8a8a2_hover _pub-3c25d522_hover hover': hover,
            '_3f8a8a2_interactive _pub-3f8a8a2_interactive _pub-3c25d522_interactive interactive': interactive,
            '_3f8a8a2_withAction _pub-3f8a8a2_withAction _pub-3c25d522_withAction withAction': withAction,
            '_3f8a8a2_spaced _pub-3f8a8a2_spaced _pub-3c25d522_spaced spaced': spaced,
            '_3f8a8a2_reverse _pub-3f8a8a2_reverse _pub-3c25d522_reverse reverse': reverse,
            '_3f8a8a2_background-secondary _pub-3f8a8a2_background-secondary _pub-3c25d522_background-secondary background-secondary': bgSecondary,
        }, className), onClick: onClick, style: style, "data-pc-label": "Card", "data-testid": testId }, children));
};
exports.Card = Card;
//# sourceMappingURL=Card.js.map